import React from 'react'
import Img from 'gatsby-image'

import LargeText from '@/large-text'
import { isDesktop } from 'u/common'

import './styles.css'

function Testimonial({ avatarSrc, name, status, comment }) {
  return (
    <div className="flex flex-wrap items-center mb5 last-child-mb0">
      <div className="f11 lh-copy pr0 pr4-l mb3 mb0-l w-100 w-25-l tc tl-l">
        <Img sizes={avatarSrc} alt="" className="w60 h60 mb2 dib" />
        <div className="fw7">{name}</div>
        <div>{status}</div>
      </div>

      <div className="w-100 w-75-l">
        <LargeText align={isDesktop ? 'left' : 'center'}>
          {comment}
        </LargeText>
      </div>
    </div>
  )
}

export default Testimonial



// WEBPACK FOOTER //
// ./src/components/testimonial/testimonial.js